import {create} from "zustand";

export const useUserProfileInfo = create((set, get) => ({
  userProfileModaVisible: false,
  handleProfileModal: () => {
    const userProfileModaVisible = !get().userProfileModaVisible;
    set({userProfileModaVisible});
  },
}));
